/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { IHistogramItemViewProps, IRatingsHistogramViewProps } from '@msdyn365-commerce-modules/ratings-reviews';
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

const RatingsHistogramView: React.FC<IRatingsHistogramViewProps> = props => {
    const { /* heading, */ histogramItems, histogramProps, moduleProps } = props;
    // @ts-ignore
    const title = props.resources.ratingReviewsText ?? '';
    return (
        <Module {...moduleProps}>
            <h4 className='ms-ratings-histogram__heading -uppercase'>{title}</h4>
            {_averageRating(props)}
            <Node {...histogramProps}>
                {histogramItems.map((item, index) => {
                    return histogramItem(item, 5 - index);
                })}
            </Node>
        </Module>
    );
};

const getStar = (star: number, value: number): string => {
    if (star - value <= 0) return '__star';
    else if (star - value > 0 && star - value < 1) return '__half-star';
    else return '__empty-star';
};

const _renderStars = (value: number, className?: string) => {
    return (
        <div aria-hidden='true' className='msc-rating__group'>
            <span className={`msc-rating${getStar(1, value)} ${className ?? ''}`} data-index='1' role='presentation'></span>
            <span className={`msc-rating${getStar(2, value)} ${className ?? ''}`} data-index='2' role='presentation'></span>
            <span className={`msc-rating${getStar(3, value)} ${className ?? ''}`} data-index='3' role='presentation'></span>
            <span className={`msc-rating${getStar(4, value)} ${className ?? ''}`} data-index='4' role='presentation'></span>
            <span className={`msc-rating${getStar(5, value)} ${className ?? ''}`} data-index='5' role='presentation'></span>
        </div>
    );
};

const _averageRating = (props: IRatingsHistogramViewProps) => {
    // @ts-ignore
    const avRating = props?.averageRating?.props?.avgRating ?? 0;
    // @ts-ignore
    const totalReviews = props?.averageNumber?.props?.summary?.reviewsCount ?? 0;
    const ratingsLabel = props?.resources?.ratingReviewsText ?? '';
    return (
        <div className='msc-average-rating-container'>
            <div className='value'>
                <span className='value__avg'>{props.context.cultureFormatter.formatNumber(avRating)}</span>
                <span>/5</span>
            </div>
            <div className='stars'>
                <span className='stars__ratings'>{`${totalReviews} ${ratingsLabel}`}</span>
                {_renderStars(avRating, 'heading')}
            </div>
        </div>
    );
};

const histogramItem = (props: IHistogramItemViewProps, starsNumber: number) => {
    return (
        <Node {...props.buttonProps}>
            {/* {props.starLabel} */}
            {_renderStars(starsNumber, 'histogram')}
            {props.bar}
            {/* {props.percentage} */}
        </Node>
    );
};

export default RatingsHistogramView;
